import revive_payload_client_YTGlmQWWT5 from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "/home/vsts/work/1/s/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_PKIXU5KmsI from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_LIYcCMJD18 from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_SeG0EjL5Ec from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_xKuw1km5sV from "/home/vsts/work/1/s/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/packages/sa-help/.nuxt/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_rsWSYU43NF from "/home/vsts/work/1/s/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_client_r3pgF3B1Uq from "/home/vsts/work/1/s/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import plugin_DtfAVtogpk from "/home/vsts/work/1/s/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import formkitPlugin_pZqjah0RUG from "/home/vsts/work/1/s/packages/sa-help/.nuxt/formkitPlugin.mjs";
import switch_locale_path_ssr_lCxu0ZmxIx from "/home/vsts/work/1/s/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_5C7QFp7tsq from "/home/vsts/work/1/s/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_zl2pp1dYXk from "/home/vsts/work/1/s/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import _0_1_vue_error_KRDOyNfx7r from "/home/vsts/work/1/s/packages/sa-help/plugins/0.1.vue-error.ts";
import _0_sentry_YD2SvzFSDA from "/home/vsts/work/1/s/packages/sa-help/plugins/0.sentry.ts";
import _1_apollo_client_JoPVSXQHw2 from "/home/vsts/work/1/s/packages/sa-help/plugins/1.apollo-client.ts";
import _2_vue_query_oNBxDDseR0 from "/home/vsts/work/1/s/packages/sa-help/plugins/2.vue-query.ts";
import _2_youtube_client_JxxZ7fNiap from "/home/vsts/work/1/s/packages/sa-help/plugins/2.youtube.client.ts";
import _3_idle_client_z5u9zlvzkc from "/home/vsts/work/1/s/packages/sa-help/plugins/3.idle.client.ts";
import _4_mask_OADB7WGOeo from "/home/vsts/work/1/s/packages/sa-help/plugins/4.mask.ts";
import _5_signature_Oril0AyBk5 from "/home/vsts/work/1/s/packages/sa-help/plugins/5.signature.ts";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  navigation_repaint_client_PKIXU5KmsI,
  check_outdated_build_client_LIYcCMJD18,
  chunk_reload_client_SeG0EjL5Ec,
  plugin_vue3_xKuw1km5sV,
  components_plugin_KR1HBZs4kY,
  prefetch_client_8FoqvPFTot,
  plugin_rsWSYU43NF,
  plugin_client_r3pgF3B1Uq,
  plugin_DtfAVtogpk,
  formkitPlugin_pZqjah0RUG,
  switch_locale_path_ssr_lCxu0ZmxIx,
  i18n_5C7QFp7tsq,
  plugin_zl2pp1dYXk,
  _0_1_vue_error_KRDOyNfx7r,
  _0_sentry_YD2SvzFSDA,
  _1_apollo_client_JoPVSXQHw2,
  _2_vue_query_oNBxDDseR0,
  _2_youtube_client_JxxZ7fNiap,
  _3_idle_client_z5u9zlvzkc,
  _4_mask_OADB7WGOeo,
  _5_signature_Oril0AyBk5
]